module.exports = __webpack_public_path__ + "assets/img/6_675_big.63fd20d8.jpg";